import React, { useCallback } from 'react'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { startQuestion } from 'src/apis/gameApi'
import { nextStep, setStep } from 'src/ducks/game'
import { AlertCard, HeaderCard } from '../styles/mobile-styles'
import GameBtn from '../GameBtn'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router'

export default function Start() {
  const dispatch = useDispatch()
  const history = useHistory()

  const { mutate } = useMutation({
    mutationFn: async () => {
      return await startQuestion(1)
    },
    onSuccess: (data) => {
      console.log('Game started successfully')
      dispatch(setStep(data.question_id))
    },
    onError: (error) => {
      console.error('Error starting the game:', error)
    },
  })

  const onStartGameHandler = useCallback(() => {
    mutate()
  }, [])

  const handleCheckLeaderboard = () => {
    history.push('/leaderboard')
  }

  const handleBackToLobby = () => {
    history.push('/lobby')
  }

  return (
    <React.Fragment>
      <HeaderCard>
        <div>
          <h1>
            Welcome to
            <br />
            <span className="font-venite">
              FAST & FURIOUS
              <br />
              TOP 30
            </span>
          </h1>
        </div>
      </HeaderCard>
      <AlertCard style={{ alignSelf: 'center' }}>
        <legend>
          <div>Terms & Conditions</div>
        </legend>
        <p>
          1) Read each question carefully. Choose the correct answer(s) and submit them in the Answer Box (some questions may have multiple correct answers).
          <br />
          <br />
          2) You may retrieve your selected answer by clicking or tapping on it, or by dragging it back to the answer options box.
          <br />
          <br />
          3) Each question will have a 20 sec time limit.
          <br />
          <br />
          4) The Top 30 participants with the fastest and highest scores will each receive RM30 Touch &lsquo;n Go eWallet credits.
          <br />
          <br />
          5) Rewards will be credited to the winners&lsquo; registered phone numbers in the company system.
          <br />
          <br />
          6) Please ensure your phone number is registered with a Touch &lsquo;n Go eWallet account.
        </p>
        <div className="d-flex flex-column justify-content-center gap-3 mt-3 align-self-center">
          <button className="game-btn start-game" onClick={onStartGameHandler}>
            Start Game
          </button>
          <div className="d-flex gap-3">
            <GameBtn onClick={handleBackToLobby}>Back to Lobby</GameBtn>
            <GameBtn onClick={handleCheckLeaderboard}>Check Leaderboard</GameBtn>
          </div>
        </div>
      </AlertCard>
    </React.Fragment>
  )
}
